import React from 'react'
import './notes-popup-teacher-portal.css'

const NotesPopupTeacherPortal = (props) => {
    const modalRef = React.useRef(null);

    React.useEffect(() => {
      const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            props.sendTheNotes()
        }
      }
    
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [modalRef]);



    return (
        <div className='notes-popup-teacher-portal__wrapper'>
            <div className='notes-popup-teacher-portal__modal' ref={modalRef}>
                <div className='notes-popup-teacher-portal__x-btn' onClick={() => props.sendTheNotes()}>x</div>
                <textarea className='notes-popup-teacher-portal__notes' value={props.teacherNotes} onChange={(e) => props.setTeacherNotes(e.target.value)} />
                <div className='notes-popup-teacher-portal__save-and-close' onClick={() => props.sendTheNotes()}>Save</div>
            </div>
        </div>
    )
}
export default NotesPopupTeacherPortal;